module.exports = __webpack_public_path__ + "img/same_score_24dp.accbd3f6.png";